// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: true,
    firebase: {
        apiKey: 'AIzaSyCmYcOVzOuZDlLkeAEis8JjP_eINjaJmNQ',
        authDomain: 'akcent-91e27.firebaseapp.com',
        databaseURL: 'https://akcent-91e27.firebaseio.com',
        projectId: 'akcent-91e27',
        storageBucket: 'akcent-91e27.appspot.com',
        messagingSenderId: '1092351644769'
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts